module.exports = __webpack_public_path__ + "static/media/tick.45a3ff76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/tick.svg
// module id = 1312
// module chunks = 0